import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { BulletPointsProps } from '@widgets/Teaser/toi/types'
import BulletPoint from './BulletPoint'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { ViewportTypeValues } from '@contexts/viewport'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

type StyledBulletPointsProps = Pick<BulletPointsProps, 'hideOnMobile'> &
  Pick<TOITeaserLayoutContextType, 'teaserFlex'>

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledBulletPoints = styled.ul<StyledBulletPointsProps>`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: {
        white,
        grey: { grey_100 },
      },
    },
    hideOnMobile,
    teaserFlex,
  }) => {
    let fontSizeDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    if (desktopTeaserFlex === '6') {
      fontSizeDesktop = `${0.02976 * teaserWidthDesktop}px`
    } else if (desktopTeaserFlex === '4') {
      fontSizeDesktop = `${0.04518 * teaserWidthDesktop}px`
    } else if (desktopTeaserFlex === '3') {
      fontSizeDesktop = `${0.04878 * teaserWidthDesktop}px`
    } else if (desktopTeaserFlex === '2') {
      fontSizeDesktop = `${0.05312 * teaserWidthDesktop}px`
    }

    let fontSizeTablet
    const tabletTeaserFlex = teaserFlex['tablet']
    const teaserWidthTablet = computeTeaserWidth({
      flexValue: tabletTeaserFlex,
      viewportType: ViewportTypeValues.TABLET,
    })

    if (tabletTeaserFlex === '6') {
      fontSizeTablet = `${0.04901 * teaserWidthTablet}px`
    } else if (tabletTeaserFlex === '3') {
      fontSizeTablet = `${0.05743 * teaserWidthTablet}px`
    }

    return css`
      list-style: none;
      padding: 0;
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 500;
      line-height: 1.2;
      text-shadow: 0 0 8px ${grey_100}, 0 0 8px ${grey_100};
      color: ${white};
      ${desktopCSS(css`
        ${!hideOnMobile &&
        css`
          display: none;
        `};
        margin: 10px 0 0 0;
        font-size: ${fontSizeDesktop};
      `)}

      ${tabletCSS(css`
        ${!hideOnMobile &&
        css`
          display: none;
        `};
        margin: 10px 0 0 0;
        font-size: ${fontSizeTablet};
      `)}

      ${mobileCSS(css`
        ${hideOnMobile &&
        css`
          display: none;
        `}
        margin: 0;
        font-size: 5.3vw;
      `)}
    `
  }}
`

const BulletPoints: FunctionComponent<BulletPointsProps> = ({
  hideOnMobile,
  bulletPoints,
}) => {
  const { teaserFlex } = useContext(TOITeaserLayoutContext)

  return (
    <StyledBulletPoints hideOnMobile={hideOnMobile} teaserFlex={teaserFlex}>
      {bulletPoints.map((bulletPointText, index) => (
        <BulletPoint key={`${index}`}>{bulletPointText}</BulletPoint>
      ))}
    </StyledBulletPoints>
  )
}

export default BulletPoints
